import * as React from 'react';
import styled from 'styled-components';
import { IToolbarItemProps, IToolbarRendererProps } from '../types';
import { ToolbarItem } from '../toolbar-item';
import { StackPanel } from '../../../stack-panel';

const Wrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    align-items: center;
    grid-template-columns: auto auto;
    background-color: ${({ theme: { toolbar } }) => toolbar.colors.backgroundColor};
`;

export const ToolbarOverflowWrap = React.memo((props: IToolbarRendererProps) => {
    const {
        primaryToolbarItems, farPositionedToolbarItems, containerRef, iconSize,
        iconPosition, separator, separatorGap, height
    } = props;

    const itemWrapperRef = React.useRef<HTMLDivElement>(containerRef.current);

    const _onRenderCommand = React.useCallback((itemProps: IToolbarItemProps, index: number) => (
        <ToolbarItem iconPosition={iconPosition} iconSize={iconSize} {...itemProps} key={itemProps.id} itemIndex={index} height={height} />
    ), [iconSize, iconPosition, height]);

    return (
        <Wrapper ref={itemWrapperRef}>
            <StackPanel gap={separatorGap} wrap height="100%" width="auto" inline separator={separator} alignment="center">
                {primaryToolbarItems.map(_onRenderCommand)}
            </StackPanel>
            {
                farPositionedToolbarItems.length ? (
                    <StackPanel gap={separatorGap} wrap height="100%" width="auto" inline separator={separator} alignment="center" justifyContent="flex-end">
                        {farPositionedToolbarItems.map(_onRenderCommand)}
                    </StackPanel>
                ) : null
            }
        </Wrapper>
    );
});

ToolbarOverflowWrap.displayName = 'ToolbarOverflowWrap';
